export default __webpack_public_path__ + "static/media/xp.095e5302.png";